import { Button, Result, Space } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminRoutes } from "router";
import { settings } from "settings";
import { permissionStore } from "store/permissionStore";
import { userStore } from "store/userStore";

export const ConnectionErrorPage = () => {
  const navigate = useNavigate();
  const [retrying, setRetrying] = useState(false);

  const handleRetry = async () => {
    setRetrying(true);
    try {
      await userStore.getProfile();
      permissionStore.accessRoutes = [...adminRoutes];
      if (settings.checkPermission && userStore.info.role) {
        await permissionStore.fetchPermissions(userStore.info.role.id);
        permissionStore.setAccessRoutes();
      }
      navigate("/");
    } catch (error: any) {
      if (error?.response?.status === 401) {
        userStore.logout();
        navigate("/login");
      }
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--app-page-bg)",
      }}
    >
      <Result
        status="error"
        title="Sự cố kết nối"
        subTitle="Không thể kết nối tới máy chủ. Vui lòng kiểm tra mạng rồi thử lại."
        extra={
          <Space>
            <Button type="primary" loading={retrying} onClick={handleRetry}>
              Thử lại
            </Button>
            <Button
              disabled={retrying}
              onClick={() => {
                userStore.logout();
                navigate("/login");
              }}
            >
              Đăng xuất
            </Button>
          </Space>
        }
      />
    </div>
  );
};
